import { InjectionToken } from '@angular/core';

export const APP_ORIGIN_NAME_TOKEN = new InjectionToken<string>('APP_ORIGIN_NAME_TOKEN');
